import React from 'react'
import styled from '@emotion/styled'

import {Alert} from '@vio/atlas/Alert'
import {Link} from '@vio/atlas/Link'
import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {Price} from '../../search/Price'
import {OfferAlertVariant} from './constants'
import {offerAlertMessages, variantTranslations} from './offerAlertMessages'

type PropsTypes = {
  variant: OfferAlertVariant
  onClick: () => void
  price?: number
  currency?: string
}

const alertVariantMap = {
  [OfferAlertVariant.PriceDropV2]: 'success',
  [OfferAlertVariant.PriceIncreaseV2]: 'warning'
} as const

const AmountPrice = styled(Price)`
  ${cssTheme.typography.titleS}
  display: inline-flex;
`

export const VariantComponent = ({
  variant,
  onClick,
  price,
  currency
}: PropsTypes) => {
  const {id, defaultMessage} = variantTranslations[variant]
  const alertVariant = alertVariantMap[variant]

  return (
    <div role="button" tabIndex={0} onClick={onClick} onKeyDown={onClick}>
      <Alert variant={alertVariant} size="compact">
        <FormattedMessageWrapper
          {...{id, defaultMessage}}
          values={{
            price: price && (
              <AmountPrice
                value={price}
                currency={currency}
                isAbbreviated
                noStyle
              />
            )
          }}
        />
        <Link>
          &nbsp;
          <FormattedMessageWrapper {...offerAlertMessages.why} />
        </Link>
      </Alert>
    </div>
  )
}
